import { Injectable } from '@angular/core';

@Injectable()
export class LzCookieService {

  constructor() {}

  createCookie(name: string, value: string, days: number): void {
    let expires;
    if (days) {
      let date: Date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date['toGMTString']();
    } else {
      expires = "";
    }
    document.cookie = name + "=" + value + expires + "; path=/; domain=.ligazakon.net";
  }

  getCookie(name: string): string {
    if (document.cookie.length > 0) {
      let c_start = document.cookie.indexOf(name + "=");
      if (c_start != -1) {
        c_start = c_start + name.length + 1;
        let c_end = document.cookie.indexOf(";", c_start);
        if (c_end == -1) {
          c_end = document.cookie.length;
        }
        return decodeURIComponent(document.cookie.substring(c_start, c_end));
      }
    }
    return "";
  }

  deleteCookie(name) {
    if (this.getCookie(name)) {
      document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/; domain=.ligazakon.net';
    }
  }

}
